import React, { useMemo } from 'react'
import WorkoutCategoryForm from './components'

export default function WorkoutCategoryAdd (props) {
  const category = useMemo(() => ({showing_type: 1, active: true, is_workout: true}), [])

  return (
    <WorkoutCategoryForm data={category} {...props} />
  )
}